import { type AxiosInstance, isAxiosError } from "axios";
import { type ReuseInfoGetAPIResponse } from "@/features/acquireBook/api/ReuseInfoAPI";

// 物件コード配下のリユース確認 API（GET .../picture-requests/acquire-reuse）。
//
// レスポンスは共有リユース機構（usePictureCheckOptionsManager / ReuseInformationRadioButtons）が扱う
// ReuseInfoGetAPIResponse 形のため、変換せずそのまま返す。
// 所在/地番はクエリに付けず物件コードのみをパスで指定する（サーバが物件コードから解決する）。

export const buildAcquireReuseEndpoint = (propertyCode: string): string =>
  `/property-codes/${propertyCode}/picture-requests/acquire-reuse`;

/**
 * 物件コードに紐づくリユース可能な登記/図面の一覧を取得する。
 * レスポンスは配列を直接返す（{ list } ラップではない）。リユース可能が無ければ []。
 * 404 は「リユース不可」とみなし [] を返す。
 * 401（accesstoken 期限切れ）の手動再試行は行わない。apiClient のレスポンスインターセプタが
 * 401 時にトークンリフレッシュ＋元リクエストの自動再実行まで行うため、この catch に 401 が届くのは
 * 「リフレッシュ自体が失敗した（実セッション切れ）」ケースで、ここで再試行しても確実に失敗する無駄なリクエストになる。
 * @param apiClient JWT 認証付き apiClient
 * @param propertyCode 物件コード（UUID）
 */
export const getAcquireReuse = async (
  apiClient: AxiosInstance,
  propertyCode: string
): Promise<ReuseInfoGetAPIResponse[]> => {
  const endpoint = buildAcquireReuseEndpoint(propertyCode);
  try {
    const { data } = await apiClient.get<ReuseInfoGetAPIResponse[]>(endpoint);
    return data;
  } catch (e) {
    if (isAxiosError(e) && e.response?.status === 404) {
      return [];
    }
    throw e;
  }
};
